export * from '@fhs/routing/src/routes/(drawer)/account/payment/_layout';
export { default } from '@fhs/routing/src/routes/(drawer)/account/payment/_layout';
